import { usePreferences } from 'context/preferences/PreferencesContext'

export const featureFlagService = () => {
  const { preferences, isLoading } = usePreferences()

  const getFeatureFlag = (flagName: string, defaultValue = false) =>
    preferences?.feature_flags?.[flagName]?.enabled ?? defaultValue

  const shouldShowMenuSize = getFeatureFlag('show_menu_size')
  const enableInstagremData = getFeatureFlag('enable_instagram_data')
  const enableInstagramPercentile = getFeatureFlag(
    'enable_instagram_percentiles'
  )
  const shouldShowMenu = getFeatureFlag('show_menu_column')
  const shouldShowReputationData = getFeatureFlag('reputation_data')
  const shouldShowDoorMenu = getFeatureFlag('show_door_menu_column')
  const enableCnUTable = getFeatureFlag('enable_cnu_table')
  const enableK12Table = getFeatureFlag('enable_k12_table')
  const enableActivityV2 = getFeatureFlag('enable_activity_v2')
  const enableRestaurantsCountryFilter = getFeatureFlag(
    'enable_restaurants_country_filter'
  )
  const enableContactRequests = getFeatureFlag('enable_contact_requests')
  const enableChainsListV2 = getFeatureFlag('chains_list_v2')
  const enableTagsSort = getFeatureFlag('enable_tags_sort')
  const enableCampaigns = getFeatureFlag('enable_campaigns')
  const enableHospitals = getFeatureFlag('enable_hospitals_table')
  const enableNursingHomes = getFeatureFlag('enable_nursing_homes_table')
  const enableRebates = getFeatureFlag('enable_rebates')
  const enableEmailIntegration = getFeatureFlag('enable_email_integration')
  const enableOppsAttrsServicesAtmosOffersHours = getFeatureFlag(
    'enable_opps_attrs_services_atmos_offers_hours'
  )
  const enableLodging = getFeatureFlag('enable_lodging_table')
  const enableConvenience = getFeatureFlag('enable_convenience_table')
  const enablePushToSalesforce = getFeatureFlag('enable_push_to_salesforce')
  const enableHQStateColumn = getFeatureFlag('enable_hq_state_column')
  const enableContactCredits = getFeatureFlag('enable_contact_credits')
  const enableNewImportTool = getFeatureFlag('enable_new_import_tool')

  return {
    shouldShowMenuSize,
    enableInstagremData,
    enableInstagramPercentile,
    shouldShowMenu,
    shouldShowReputationData,
    shouldShowDoorMenu,
    enableCnUTable,
    enableK12Table,
    enableActivityV2,
    enableRestaurantsCountryFilter,
    enableContactRequests,
    enableChainsListV2,
    enableTagsSort,
    enableCampaigns,
    enableHospitals,
    enableNursingHomes,
    enableRebates,
    enableEmailIntegration,
    enableOppsAttrsServicesAtmosOffersHours,
    enableLodging,
    enableConvenience,
    enablePushToSalesforce,
    enableHQStateColumn,
    enableContactCredits,
    enableNewImportTool,
    isLoading,
  }
}
